module.exports = "/_next/static/images/manage-expenses-0430789ba3b3e928bcdc231cc33d8f25.jpg";